export const createUserProfileURL = '/customers/v2/enroll'
export const getUserProfileURL = '/customers/v2/profile'
export const updateUserProfileURL = `/customers/customers/updateProfile`
export const getReferralCodeURL = `/customers/referral/code`
export const ageVrificationURL = `/v4/users/me/age-verification`
